import ProofDeclarationDetail from "./proofDeclarationDetail";
export default ProofDeclarationDetail;